import { render, staticRenderFns } from "./ShipmentDeliveryNotePdfPopUp.vue?vue&type=template&id=470bf09d&scoped=true&"
import script from "./ShipmentDeliveryNotePdfPopUp.vue?vue&type=script&lang=js&"
export * from "./ShipmentDeliveryNotePdfPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDeliveryNotePdfPopUp.vue?vue&type=style&index=0&id=470bf09d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470bf09d",
  null
  
)

export default component.exports